export default __webpack_public_path__ + "static/media/BeltlineLoading.dc085af5.gif";